/*************************************************************************
 * Generated by RxDjango on 2026-05-14 19:30 (UTC)                       *
 *                                                                       *
 * Based on all ContextChannel subclasses in authorization_meta.channels *
 *                                                                       *
 *                         DO NOT EDIT THIS FILE                         *
 *                                                                       *
 * To rebuild it, run:                                                   *
 *                                                                       *
 *     ./manage.py makefrontend [authorization_meta]                     *
 *                                                                       *
 *************************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class AuthorizationMetaChannel extends ContextChannel {

  protected endpoint: string = "/ws/authorization_meta/";
  protected baseURL: string = SOCKET_URL;

  authorized: boolean = false;
  counter: number = 0;

  authorize = async (password: string) => {
    return await this.rx.callAction('authorize', [password]);
  };

  increment = async () => {
    return await this.rx.callAction('increment', []);
  };
}
